import React from 'react';

// Hooks
import ReceptionProvider from '../../../hooks/reception/ReceptionProvider';

// Models
import { states, subTypes, types } from '../../../models/MovementEntity';

import ReceptionEdition from './main';

const ReceptionView = () => {
    const movement = {
        reason: '',
        type: types.Ingress,
        subType: subTypes.Reception,
        state: states.Accepted,
        details: [],
        products: [],
        referrals: []
    }

    return (
        <ReceptionProvider movement={movement}>
            <ReceptionEdition />
        </ReceptionProvider>
    )
}

export default ReceptionView;